const Input = ({
    value,
    onChange,
    name,
    placeholder,
    className,
    width = "w-full",
    allowDecimal = false,
    ...props
}) => {
    const handleChange = (e) => {
        let newValue = e.target.value;

        // If it's a number input and decimals are not allowed
        if (props.type === "number" && !allowDecimal && newValue !== "") {
            // Remove any decimal points and everything after
            newValue = newValue.split(".")[0];
        }

        onChange(name, newValue);
    };

    return (
        <input
            type="text"
            id={name}
            name={name}
            value={value}
            onChange={handleChange}
            onKeyPress={(e) => {
                // Prevent decimal point if not allowed
                if (
                    props.type === "number" &&
                    !allowDecimal &&
                    (e.key === "." || e.key === ",")
                ) {
                    e.preventDefault();
                }
            }}
            placeholder={placeholder}
            className={`${width} px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-outer-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-inner-spin-button]:m-0 ${className}`}
            step={props.type === "number" && !allowDecimal ? "1" : props.step}
            {...props}
        />
    );
};
export default Input;
